import { ISidebar } from "./sidebar-panel"
import { $uniUP } from "../.."
import { NotificacionService } from "../../../uni-base/services/NotifService"

// title="Tipos de catálogo" open="left"
export class SidebarManagerController implements ng.IComponentController {
  private sidebars: { [key: string]: ISidebar }

  constructor(
    private $log: ng.ILogService,
    private NotifService: NotificacionService
  ) { }

  $onInit() {
    this.sidebars = {}
  }

  getSidebar(key: string): ISidebar | null {
    let s = this.sidebars[key]

    return (
      s || ((this.NotifService.aviso("Sidebar no encontrado") as any) || null)
    )
  }

  registraSidebar(key: string, sidebar: ISidebar) {
    this.sidebars[key] = sidebar
  }

  togglePanel(panelKey: string): any {
    console.log(`abrirPanel ${panelKey} ****`)

    // this.onPanelEmpresas()

    let sidebarInstance = this.getSidebar(panelKey)

    this.$log.info("sidebar AVISOS", sidebarInstance)

    sidebarInstance && sidebarInstance.toggle()
  }
}

/**
 * Panel lateral de acceso rápido a los tipos de catálogo
 */
$uniUP.component("sidebarManager", {
  bindings: {},
  controller: SidebarManagerController
  // transclude: true,
  // template : "<ng-transclude></ng-transclude>"
})
